import React from 'react';
import { CalendarDaysIcon, ClockIcon, MessageSquareIcon, PrinterIcon } from 'lucide-react';
import { fitTags } from '../data/kit';
const metrics = [{
  Icon: CalendarDaysIcon,
  value: '13',
  label: 'Weekly plans'
}, {
  Icon: ClockIcon,
  value: '45 MIN',
  label: 'Structured encounters'
}, {
  Icon: MessageSquareIcon,
  value: 'Step by step',
  label: 'Read-aloud guidance'
}, {
  Icon: PrinterIcon,
  value: 'Print & adapt',
  label: 'Resources & options'
}];
export function SolutionSection() {
  return <section className="section solution mid" id="the-solution" data-id="element-227" data-mp="3t96oxcr7d5ga">
      <div className="wrap" data-id="element-228" data-mp="aue8q4u338od">
        <div className="section-heading" data-id="element-229" data-mp="auno6yhi5xft">
          <p className="tag" data-id="element-230" data-mp="atmasnd0kyux">A complete encounter, already organized</p>
          <h2 data-id="element-231" data-mp="5wch2vile11a">
            Kids Activity <span className="accent" data-id="element-232" data-mp="5w2vdk4kyg1e">Club</span>
          </h2>
          <p data-id="element-233" data-mp="ktmzypxke971">
            A practical planning kit for adult coordinators of children’s clubs, play centers and recreational
            workshops. Choose the week and follow a complete sequence, from the welcome to the closing.
          </p>
        </div>
        <div className="solution-metrics" data-id="element-234" data-mp="36cyoe69kzkk6">
          {metrics.map(({
          Icon,
          value,
          label
        }) => <div key={label} className="metric" data-id="element-235" data-mp="3bbjqkb8e8eb9">
              <Icon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-236" data-mp="3faiuptmaw71n" />
              <strong data-id="element-237" data-mp="3kawu6n9u68o2">{value}</strong>
              <span data-id="element-238" data-mp="3kbyfrlohadk1">{label}</span>
            </div>)}
        </div>
        <div className="fit-box" data-id="element-239" data-mp="3p8f52j7eyxyp">
          <p className="eyebrow" data-id="element-240" data-mp="3p984t07ygn7c">Movement, thinking and teamwork — in one organized session</p>
          <div className="fit-tags" data-id="element-241" data-mp="3u6qfow5j9chz">
            {fitTags.map(tag => <span key={tag} data-id="element-242" data-mp="2v6u2l7z2oit">{tag}</span>)}
          </div>
        </div>
      </div>
    </section>;
}